export const initialOrders = [
  {
    id: 'ord-001',
    tilda_order_id: '100234',
    name: 'Alex Johnson',
    phone: '+1 555 010 9988',
    cinema_name: 'Heroes Playbar',
    hall: '3',
    hall_row: '8',
    hall_seat: '12',
    products: '2x Large Popcorn, 1x Cola Zero (L), 1x Nachos Cheese',
    status: 'Received',
    created_at: new Date(Date.now() - 1000 * 60 * 5).toISOString(),
    comments: 'Extra napkins please'
  },
  {
    id: 'ord-002',
    tilda_order_id: '100235',
    name: 'Sarah Connor',
    phone: '+1 555 020 7766',
    cinema_name: 'Heroes Playbar',
    hall: 'IMAX',
    hall_row: '12',
    hall_seat: '15',
    products: '1x Hot Dog, 1x Beer (0.5)',
    status: 'Preparing',
    created_at: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    comments: ''
  },
  {
    id: 'ord-003',
    tilda_order_id: '100236',
    name: 'Mike Ross',
    phone: '+1 555 030 5544',
    cinema_name: 'Heroes Playbar',
    hall: '1',
    hall_row: '5',
    hall_seat: '8',
    products: '1x Combo #3 (Popcorn + 2 Drinks)',
    status: 'Delivering',
    created_at: new Date(Date.now() - 1000 * 60 * 25).toISOString(),
    comments: 'Call when near'
  },
  {
    id: 'ord-004',
    tilda_order_id: '100237',
    name: 'Elena Fisher',
    phone: '+1 555 040 3322',
    cinema_name: 'Heroes Playbar',
    hall: 'VIP',
    hall_row: '2',
    hall_seat: '4',
    products: '1x Champagne, 1x Fruit Platter',
    status: 'Completed',
    created_at: new Date(Date.now() - 1000 * 60 * 60).toISOString(),
    comments: ''
  },
  {
    id: 'ord-005',
    tilda_order_id: '100238',
    name: 'John Wick',
    phone: '+1 555 000 1111',
    cinema_name: 'Heroes Playbar',
    hall: '4',
    hall_row: '9',
    hall_seat: '9',
    products: '1x Black Coffee, 1x Water',
    status: 'Received',
    created_at: new Date(Date.now() - 1000 * 60 * 2).toISOString(),
    comments: 'No sugar'
  },
  {
    id: 'ord-006',
    tilda_order_id: '100239',
    name: 'Diana Prince',
    phone: '+1 555 050 2233',
    cinema_name: 'Heroes Playbar',
    hall: '2',
    hall_row: '6',
    hall_seat: '10',
    products: '2x Medium Popcorn, 2x Sprite (M)',
    status: 'Archived',
    created_at: new Date(Date.now() - 1000 * 60 * 120).toISOString(),
    comments: ''
  },
  {
    id: 'ord-007',
    tilda_order_id: '100240',
    name: 'Bruce Wayne',
    phone: '+1 555 060 4455',
    cinema_name: 'Heroes Playbar',
    hall: 'VIP',
    hall_row: '1',
    hall_seat: '5',
    products: '1x Whiskey, 1x Steak',
    status: 'Archived',
    created_at: new Date(Date.now() - 1000 * 60 * 180).toISOString(),
    comments: 'VIP treatment'
  }
];

export const COLUMNS = {
  Received: {
    title: 'New Orders',
    color: 'bg-gradient-to-r from-amber-400 to-yellow-400 text-black',
    accent: 'border-l-4 border-amber-400'
  },
  Preparing: {
    title: 'Kitchen',
    color: 'bg-gradient-to-r from-blue-500 to-blue-600 text-white',
    accent: 'border-l-4 border-blue-500'
  },
  Delivering: {
    title: 'Delivery',
    color: 'bg-gradient-to-r from-purple-500 to-purple-600 text-white',
    accent: 'border-l-4 border-purple-500'
  },
  Completed: {
    title: 'Done',
    color: 'bg-gradient-to-r from-green-600 to-green-700 text-white',
    accent: 'border-l-4 border-green-600'
  },
  Archived: {
    title: 'Archive',
    color: 'bg-gradient-to-r from-zinc-700 to-zinc-800 text-zinc-300',
    accent: 'border-l-4 border-zinc-600'
  }
};